import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'ds-report-view-button',
  templateUrl: './report-view-button.component.html',
  styleUrls: ['./report-view-button.component.scss']
})
export class ReportViewButtonComponent implements OnInit {

  @Input() view: string;
  @Output() viewChange = new EventEmitter<string>();

  constructor() { }

  ngOnInit() {
    if (!this.isViewCorrect(this.view)) {
      this.changeView('analysis');
    }
  }

  changeView(view?: string) {
    if (view && this.isViewCorrect(view)) {
      this.view = view;
    }

    switch (this.view) {
      case 'analysis':
        this.view = 'details';
        break;
      case 'details':
        this.view = 'analysis';
        break;
    }

    this.viewChange.emit(this.view);
  }

  isViewCorrect(view: string): boolean {
    return view && (view === 'analysis' || view === 'details');
  }

}
